export function formatString(template, ...args) {
	if (template == null) {
		return '';
	}

	return String(template).replace(/{(\d+)}/g, (match, number) => (
		typeof args[number] !== 'undefined'
			? args[number]
			: match
	));
}

export function trimChar(value, charToRemove) {
	let text = String(value ?? '');

	while (text.charAt(0) === charToRemove) {
		text = text.substring(1);
	}

	while (text.charAt(text.length - 1) === charToRemove) {
		text = text.substring(0, text.length - 1);
	}

	return text;
}

export function isNullOrWhiteSpace(value) {
	return (value == null) || (String(value).trim() === '');
}

export function isNotNullOrWhiteSpace(value) {
	return !isNullOrWhiteSpace(value);
}

export function slugify(value) {
	const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;';
	const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnooooooooprrsssssttuuuuuuuuuwxyyzzz------';
	const pattern = new RegExp(a.split('').join('|'), 'g');

	return String(value ?? '')
		.toLowerCase()
		.replace(/\s+/g, '-')
		.replace(pattern, (char) => b.charAt(a.indexOf(char)))
		.replace(/&/g, '-and-')
		.replace(/[^\w\-]+/g, '')
		.replace(/\-\-+/g, '-')
		.replace(/^-+/, '')
		.replace(/-+$/, '');
}
